import { AbstractSignupFormController, AbstractUserLoaderer } from '../../generated'

export default AbstractSignupFormController

/** @constructor @extends {AbstractSignupFormController} @suppress {checkTypes} */ function _SignupFormController() {}
AbstractSignupFormController.__implement(AbstractUserLoaderer,
 _SignupFormController.prototype = /** @type {!AbstractSignupFormController} */ ({

 }),
)